import 'lessRoot/subscriptions/farms-landing-page.less';
import Price from "JS/components/price/Price.vue";
import Vue from 'vue';
import { createListSlider } from "../list-slider";
import { onWindowResize } from "../utilities/viewport";

const priceRoots: NodeListOf<HTMLElement> = document.querySelectorAll("[data-product]");
for (const el of priceRoots) {
	const productIn = JSON.parse(el.dataset.product);
	new Vue({
		el,
		render: h => h(Price, {
			props: {
				price: productIn.price,
				showGetQuote: productIn.showGetQuote,
				showInStoreOnlyMessage: productIn.showInStoreOnlyMessage,
				isComingSoon: productIn.isComingSoon
			}
		})
	});
}

const carousels = document.querySelectorAll(".styled-widget-carousel");
for (let i = 0; i < carousels.length; i++) {
	const viewport: HTMLElement = carousels[i].querySelector('[data-list-slider-viewport]');
	if (viewport) {
		const listSlider = createListSlider(viewport);
		listSlider.setControls(carousels[i].querySelector(".carousel__button-back"), carousels[i].querySelector(".carousel__button-forward"));
		onWindowResize(() => listSlider.reset());
	}
}
